const urlRegex = /\s*window\.location\.href\s*=\s*['"]([^'"]+)['"]/;

export function determineRedirectPathInputValue(apiResponseHandler, page) {

  const lines = (apiResponseHandler || '').split('\n').filter(line => line.trim() !== '');

  // If lines are more than 3, user have modified the action. They will know the meaning of 'Custom action defined!'
  if (lines.length !== 3) {
    return 'Custom action defined!';
  }

  const redirectLineIndex = lines.findIndex(line => line.indexOf('window.location.href = ') !== -1);

  // If redirect line is not preset, user have modified the action.
  if (redirectLineIndex === -1) {
    return 'Custom action defined!';
  }

  const line = lines[redirectLineIndex];

  // If redirect line is default, page path is the redirect path
  if (line.indexOf('window.location.href = window.location.href;') !== -1) {
    return page.path;
  }

  var match = line.match(urlRegex);

  if (match) {
    var extractedUrl = match[1];
    return extractedUrl;
  } else {
    return 'Custom action defined!';
  }

}